export default __webpack_public_path__ + "static/media/ReceiveOrderDisable.0ce36fe5.svg";